import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { getOrderColumns } from "../components/Order/orderColumns";
import { useAuth } from "../context/AuthProvider";
import { API_BASE_URL } from '../api';

export default function useOrderColumns({
    onNewInvoice,
    onCreateReturn,
    onCancelOrder,
    onReload,
    excludeColumns = []
}) {
    const { t } = useTranslation();
    const { hasRight } = useAuth();
    const canCancel = hasRight('ORDERS_CANCEL');
    const canCreateReturn = hasRight('RETURNS_CREATE');
    // Upper end of the Total / Collected filter sliders — the highest order total, rounded up.
    const [amountMax, setAmountMax] = useState(1000);

    useEffect(() => {
        axios.get(`${API_BASE_URL}/api/v1/getOrders`, {
            params: { page: 0, size: 1, sortField: 'total', sortDirection: 'desc' },
            withCredentials: true,
        })
            .then(({ data }) => {
                const top = Number(data.content?.[0]?.total);
                if (top > 0) setAmountMax(Math.ceil(top / 100) * 100);
            })
            .catch(() => {});
    }, []);

    const columns = useMemo(() => {
        const updateOrderStatus = async (orderId, orderStatus) => {
            try {
                await axios.patch(
                    `${API_BASE_URL}/api/v1/orders/${orderId}/status`,
                    { status: orderStatus },
                    { withCredentials: true }
                );

                onReload?.();
            } catch (error) {
                console.error("Failed to update order:", error);
            }
        };

        let cols = getOrderColumns({
            openNewInvoiceModal: onNewInvoice,
            openCreateReturnModal: onCreateReturn,
            updateOrderStatus,
            onCancelOrder,
            onReload,
            canCancel,
            canCreateReturn,
            amountMax,
            t,
        });

        if (excludeColumns.length > 0) {
            cols = cols.filter(col => !excludeColumns.includes(col.accessor));
        }

        return cols;
    }, [onNewInvoice, onCreateReturn, onCancelOrder, onReload, excludeColumns, canCancel, canCreateReturn, amountMax, t]);

    return columns;
}